import React, { useEffect, useRef, useState } from 'react';
import ChevronUp32 from '@carbon/icons-react/lib/chevron--up/32';
import './Accordion.scss';
import { ModeSwitcher } from '../ModeSwitcher/ModeSwitcher';
import { Mode } from '../../enums';
import { FormattedMessage } from 'react-intl';
import messages from '../../locales/messages';

interface Props {
  widgetHeight: number;
  mode: Mode;
  setMode: (newMode: Mode) => void;
}

const AccordionItem: React.FC<Props> = ({ widgetHeight, mode, setMode }) => {
  const [isListOpen, setIsListOpen] = useState(false);
  const accordionRef = useRef<HTMLDivElement | null>(null);
  const [button, setButton] = useState<HTMLButtonElement | null>(null);
  const [buttonHeight, setButtonHeight] = useState(0);
  const onModeSelect = (mode: Mode) => {
    setMode(mode);
    setIsListOpen(false);
  };

  const getIconClass = () => {
    const isOpen = 'chevron-down';
    const isClosed = 'chevron-up';
    switch (isListOpen) {
      case true:
        return isOpen;
      case false:
        return isClosed;
      default:
        return isClosed;
    }
  };

  useEffect(() => {
    if (!button) return;
    const observer = new ResizeObserver(([entry]) => {
      setButtonHeight(entry.target.clientHeight);
    });
    observer.observe(button);
    return () => {
      observer.unobserve(button);
      observer.disconnect();
    };
  }, [button]);

  return (
    <div className="accordion-bars__item-wrapper">
      <div
        ref={accordionRef}
        className={`accordion-bars__item-wrapper-inner
        ${isListOpen ? 'accordion-bars__item-wrapper-inner--expanded' : ''}`}
        style={{
          height: isListOpen ? `${widgetHeight - buttonHeight}px` : 0,
        }}
      >
        {<ModeSwitcher mode={mode} onChange={onModeSelect} />}
      </div>
      <button
        ref={setButton}
        className={`accordion-bars__btn
        ${isListOpen ? 'accordion-bars__btn--active' : ''}`}
        onClick={() => setIsListOpen((value) => !value)}
      >
        <div className="accordion-bars__title">
          <FormattedMessage {...messages.dropdownLabel} />
        </div>
        <div className="accordion-bars__chevron-wrapper">
          <ChevronUp32
            className={`accordion-bars__chevron ${getIconClass()}`}
          />
        </div>
      </button>
    </div>
  );
};

export default AccordionItem;
